/** Information about a list of words */
export interface ListInfoDto {
    displayName: string;
    listId: string;
    listWordSetId: string;
}

/** Special list id that allows every word in the dictionary */
export const ANY_WORD_LIST_ID = 'any';

/** The list of words that are linked to a ListInfo */
export interface WordList {
    [key: string]: Record<string, boolean>;
}

/** Kana readings for a kanji written form, keyed to the image that identifies the exact word. */
export type KanjiLookup = Record<string, string>;

export interface ShiritoriWordDto {
    bccwjRank?: number;
    core10kId: number;
    imageId: string;
    jmDictId: number;
    kana: string;
    meaning: string;
    rank: number;
    romaji: string;
    writtenForm: string;
    wordId: string;
}

/** A set of words, grouped by kana homonym, keyed by meaning */
export type ShiritoriWordGroup = Record<string, ShiritoriWordDto>;
